import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-footer-info',
  components: {},
})
export default class FooterInfo extends Vue {
  @Prop() readonly formModel: any;

  isModuleActivated(module: string): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper[module]);
  }

  get isSuperAdmin(): boolean {
    return this.$store.getters['auth/isSuperAdmin'];
  }

  get formatedCreatedDate() {
    return this.formModel?.created_at
      ? this.$bpcHelper.formatDateV2(this.formModel.created_at)
      : null;
  }
  get formatedCreatedTime() {
    const date = new Date(this.formModel?.created_at);
    return this.formModel?.created_at ? this.$bpcHelper.formatDateTime2Time(date) : null;
  }
  get formatedUpdatedDate() {
    return this.formModel?.updated_at
      ? this.$bpcHelper.formatDateV2(this.formModel.updated_at)
      : null;
  }
  get formatedUpdatedTime() {
    const date = new Date(this.formModel?.updated_at);
    return this.formModel?.updated_at ? this.$bpcHelper.formatDateTime2Time(date) : null;
  }
}
